import { useEffect, useState } from "react";
import adminApi from "../api/adminApi";

// Loads the year's student list once (the same source the main student search
// uses) so the audit filter can match client-side by name, MT ref OR id number.
// The actual filtering happens in the Autocomplete (filterOptions), so typing
// never fires a network call and a numeric id resolves to the real student.
export default function useStudentSearch(setBanner, year) {
  const [studentOptions, setStudentOptions] = useState([]);
  const [studentSearchLoading, setStudentSearchLoading] = useState(false);
  const [studentSearchTerm, setStudentSearchTerm] = useState("");

  useEffect(() => {
    if (!year) {
      setStudentOptions([]);
      return undefined;
    }

    let cancelled = false;
    setStudentSearchLoading(true);

    adminApi
      .getStudentsForYear(year)
      .then((data) => {
        if (cancelled) return;
        const list = Array.isArray(data)
          ? data.map((student) => ({
              id: student.id,
              label: `${student.studentName || ""} ${student.studentSurname || ""}`.trim(),
              mtRef: student.mtRef || "",
            }))
          : [];
        setStudentOptions(list);
      })
      .catch((error) => {
        if (!cancelled) {
          setBanner({ type: "error", text: error.message || "Failed to load students" });
        }
      })
      .finally(() => {
        if (!cancelled) setStudentSearchLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [year, setBanner]);

  const clearStudentSearch = () => {
    setStudentSearchTerm("");
  };

  return {
    studentOptions,
    studentSearchLoading,
    studentSearchTerm,
    setStudentSearchTerm,
    clearStudentSearch,
  };
}
